/**
 * Tier Level is PAUSED (founder, 2026-10-22: "hold off on Tier Level for now,
 * keep at 10% and we can add it in later as a new feature").
 *
 * Every talent pays the Bronze 10% fee on new requests (server
 * lib/feeTiers.js tiersPaused; an admin-set rate below 10% still wins), and
 * no tier surface shows anywhere: the Tier Level card and sheet, "$X to go →
 * Silver" in Insights, the "jump a tier" card in Refer & Earn, the tiers
 * slide in the first-run tour, and the tier pill on the admin talent card.
 *
 * The server also answers GET /orders/fee-tier with { enabled: false,
 * paused: true } while paused, which is what hides tiers in the app builds
 * already on phones. This switch hides the surfaces that don't ask the
 * server (the tour slide) and keeps the rest hidden whatever the server says.
 *
 * TO BRING TIERS BACK: set this to true AND TIERS_PAUSED=0 on the server.
 */
export const SHOW_TIERS = false;
